import axios from 'axios';

// ============================================================================
// EMAILJS CONFIGURATION
// ============================================================================
// You must sign up at https://www.emailjs.com/ and create an Email Service 
// and an Email Template. Then, replace these placeholder values with your actual keys.
//
// 1. SERVICE_ID: Found in the "Email Services" tab.
// 2. TEMPLATE_ID: Found in the "Email Templates" tab.
// 3. PUBLIC_KEY: Found in "Account" -> "API Keys" -> "Public Key".
// ============================================================================

const EMAILJS_SERVICE_ID = "YOUR_SERVICE_ID_HERE";
const EMAILJS_TEMPLATE_ID = "YOUR_TEMPLATE_ID_HERE";
const EMAILJS_PUBLIC_KEY = "YOUR_PUBLIC_KEY_HERE";

export const sendSubscriptionEmail = async (userEmail) => {
  // If the credentials are not set up yet, we will just simulate success in the console
  if (EMAILJS_SERVICE_ID === "YOUR_SERVICE_ID_HERE") {
    console.warn("⚠️ EmailJS is not configured. Simulating email send to:", userEmail);
    console.log("Email content: Welcome to Bamboosa Offers! We will notify you of any new festival offers.");
    return Promise.resolve({ status: 200, text: "Simulated Success" });
  }

  const data = {
    service_id: EMAILJS_SERVICE_ID,
    template_id: EMAILJS_TEMPLATE_ID,
    user_id: EMAILJS_PUBLIC_KEY,
    template_params: {
      to_email: userEmail,
      subject: "Welcome to Bamboosa Offers!",
      message: "Thank you for subscribing to Bamboosa! We will notify you whenever an exclusive offer or new coupon is added."
    }
  };

  try {
    const response = await axios.post('https://api.emailjs.com/api/v1.0/email/send', data);
    return response;
  } catch (error) {
    console.error("Failed to send subscription email:", error);
    throw error;
  }
};
